const QueueRow = ({ title, subtitle, meta, actions, onClick }) => {
  const isInteractive = Boolean(onClick);
  return (
    <div
      onClick={onClick}
      role={isInteractive ? "button" : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      className={`flex flex-wrap items-center justify-between gap-3 rounded-xl border border-border-muted bg-white p-3 transition dark:border-navy-700 dark:bg-navy-800 ${
        isInteractive ? "cursor-pointer hover:border-info-200 hover:bg-info-50/40" : ""
      }`}
    >
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-navy-700 dark:text-white">
          {title}
        </p>
        {subtitle ? (
          <p className="truncate text-xs text-gray-500">{subtitle}</p>
        ) : null}
        {meta ? (
          <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-gray-500">
            {meta}
          </div>
        ) : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </div>
  );
};

export default QueueRow;
